var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2688 7.3527L12.25 6.17432V2.64242C12.25 2.15413 11.9594 1.71794 11.5188 1.54541L8.39375 0.324707C8.14063 0.223796 7.85938 0.223796 7.60313 0.324707L4.47813 1.54541C4.0375 1.71794 3.74688 2.15413 3.74688 2.64242V6.17432L0.728125 7.3527C0.290625 7.52523 0 7.96143 0 8.44971V12.0337C0 12.4764 0.240625 12.8833 0.621875 13.0819L3.74688 14.7095C4.0625 14.8755 4.4375 14.8755 4.75313 14.7095L8 13.0168L11.2469 14.7095C11.5625 14.8755 11.9375 14.8755 12.2531 14.7095L15.3781 13.0819C15.7594 12.8833 16 12.4764 16 12.0337V8.44971C16 7.96143 15.7094 7.52523 15.2688 7.3527ZM11.1875 6.20036L8.53125 7.23877V5.01872L11.1875 3.81429V6.20036ZM4.8125 2.59684L8 1.35335L11.1875 2.59684V2.61637L8 3.96403L4.8125 2.61637V2.59684ZM7.4375 12.0728L4.78125 13.4562V10.8813L7.4375 9.61833V12.0728ZM7.4375 8.42692L4.25 9.77458L1.0625 8.42692V8.40739L4.25 7.1639L7.4375 8.40739V8.42692ZM14.9375 12.0728L12.2813 13.4562V10.8813L14.9375 9.61833V12.0728ZM14.9375 8.42692L11.75 9.77458L8.5625 8.42692V8.40739L11.75 7.1639L14.9375 8.40739V8.42692Z",
    fill: "#808282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/CoinIcon.4fcacf34eb598063f73bc666b165310e.svg";
export { ForwardRef as ReactComponent };